import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GetSnippetPathsParams, SnippetPathsResponse } from '../../../../shared/snippets';

/**
 * Function to fetch snippet paths.
 * Note that we don't use this hook like other React Query hooks,
 * we use it with `ensureQueryData` which requires that we provide it a fetch function directly.
 * @param {string} locator - User project locator.
 * @param {GetSnippetPathsParams} params - The request query params
 */
export function getSnippetPaths(
  locator: string,
  params: GetSnippetPathsParams,
) {
  return get<SnippetPathsResponse>(`/api/revisions/${nuc(locator)}/snippets/paths`, false, params);
}

export const getSnippetPathsQueryKey = (locator: string, params: GetSnippetPathsParams): QueryKey => ['revisions', locator, 'snippets', 'paths', params];

/**
 * useSnippetPaths is a hook that fetches and returns the snippet paths for the given locator.
 */
export default function useSnippetPaths(locator: string, params: GetSnippetPathsParams) {
  return useQuery<SnippetPathsResponse>({
    queryKey: getSnippetPathsQueryKey(locator, params),
    queryFn: () => getSnippetPaths(locator, params),
  });
}
